import { AvailableComponents } from "./Components";

export default function Box({ config }) {  
  return (
    <div className="info-section" style={{...(config.style || {})}}>
      {config.content.map((content, i) => {
        const Component = AvailableComponents[content.type];
        if (!Component) return null;
        return <Component key={"component-" + i} config={content.settings} />;
      })}
    </div>
  );
}
